import $ from 'jquery';

/* accordion */
$(document).ready(function () {
    $('.accordion__header').click(function(){
        $(this).parent().siblings().removeClass('expand').find('.accordion__content').slideUp(500);
        $(this).parent().toggleClass('expand').find('.accordion__content').slideToggle(500);
    });
});